import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserCameraAnimationDemo from 'src/games/demos/phaserCameraAnimationDemo/Main';

interface CameraAnimationDemoProps extends PageProps<{}> {
}

class CameraAnimationDemo extends React.Component<CameraAnimationDemoProps> {
    constructor(props: CameraAnimationDemoProps) {
        super(props);
        bindAllOfThis(this, CameraAnimationDemo.prototype);
    }

    render() {
        return <div>
            <PhaserCameraAnimationDemo />
        </div>;
    }
}

export default CameraAnimationDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/CameraAnimationsDemo.tsx